import { enumOptions } from '@utils/enumOptions';

export const userRole = {
  SUPERADMIN: 'superadmin',
  STAFF: 'staff',
  FACILITY: 'facility',
  PROVIDER: 'provider',
  CLIENT: 'client',
};

export const userRoleLabel = {
  [userRole.SUPERADMIN]: 'Superadmin',
  [userRole.STAFF]: 'Staff',
  [userRole.FACILITY]: 'Facility',
  [userRole.PROVIDER]: 'Provider',
  [userRole.CLIENT]: 'Client',
};

export const userRolesOptions = enumOptions(userRoleLabel);
